import { register } from '@shopify/theme-sections'

import $ from 'jquery'

import '../../styles/sections/section-compare-table.scss'

export default register(`section-compare-table`, {

  onLoad() {
    $(document).on(`click`, `.compare-content-collapse`, function(){
      $(this).toggleClass(`see-less`)
      if($(this).hasClass(`see-less`)){
        $(this).text(`See less`)
        $(this).closest(`.bottom_content_compare_table`).removeClass(`show-overlay`)
        $(this).closest(`.bottom_content_compare_table`).find(`.bottom_full_content_compare`).show()
        $(this).closest(`.bottom_content_compare_table`).find(`.bottom_truncate_content_compare`).hide()
      }else{
        $(this).text(`See more`)
        $(this).closest(`.bottom_content_compare_table`).addClass(`show-overlay`)
        $(this).closest(`.bottom_content_compare_table`).find(`.bottom_full_content_compare`).hide()
        $(this).closest(`.bottom_content_compare_table`).find(`.bottom_truncate_content_compare`).show()
      }
    })
  },

  onUnload() {
  },
})
